module.exports = __webpack_public_path__ + "static/media/Sharp-Technology-MIP-Power-Consumption-1.87efc1b9.png";